let model: any = null;
let currentExpression: string = 'neutral';

const EMOTION_TO_EXPRESSION: Record<string, string> = {
  neutral: 'default',
  happy: 'happy',
  excited: 'happy',
  annoyed: 'angry',
  thoughtful: 'think',
  sad: 'sad',
  surprised: 'surprise',
  laughing: 'happy',
};

export function setModel(live2dModel: any): void {
  model = live2dModel;
}

export function setEmotion(emotion: string): void {
  if (!model) return;

  const expression = EMOTION_TO_EXPRESSION[emotion] || 'default';

  if (expression === currentExpression) return;

  try {
    model.expression(expression);
    currentExpression = expression;
  } catch {
    try {
      model.expression('default');
      currentExpression = 'default';
    } catch {
      // No expressions available
    }
  }
}

export function getCurrentExpression(): string {
  return currentExpression;
}

export function resetExpression(): void {
  setEmotion('neutral');
}
